import type { Locale } from '@sharesight/gatsby-plugin-sharesight-localization';

import type { ContentfulLocale } from 'hooks/useContentfulLocales';

export const sortLocales = <T extends Locale = Locale>(
  locales: T[],
  firstLocale: Locale | ContentfulLocale
): T[] =>
  locales.sort((a, b) => {
    if (a.id === firstLocale.id) return -1000;
    if (b.id === firstLocale.id) return 1000;

    return a.id.localeCompare(b.id);
  });
